import { Link } from 'react-router-dom';
import { Box, Icon, Text } from '@chakra-ui/react';
import { ReactComponent as DownloadIcon } from 'assets/icons/download.svg';
import { useTranslation } from 'localization';
import { routes } from 'statics';

import { Button } from 'components/core';

type AuthSuggestionType = {
  include: ('sign-up' | 'sign-in' | 'forget-password')[];
};

const AuthSuggestion: React.FC<AuthSuggestionType> = ({
  include,
}: AuthSuggestionType) => {
  const { t } = useTranslation('component.auth.suggestion');

  return (
    <Box textAlign="center" pb={8}>
      {include.includes('forget-password') && (
        <Text fontSize="md" fontFamily="Satoshi" pt={5} color="secondary2">
          {t('forgotPassword')}
          <Link
            to={routes.auth.forgotPassword.url}
            style={{ display: 'inline-block' }}
          >
            <Text color="primary">{t('click')}</Text>
          </Link>
        </Text>
      )}
      {include.includes('sign-up') && (
        <Text fontSize="md" fontFamily="Satoshi" pt={5} color="secondary2">
          {t('doNotHaveAnAccount')}
          <Link to={routes.auth.signUp.url} style={{ display: 'inline-block' }}>
            <Text color="primary">{t('signUp')}</Text>
          </Link>
        </Text>
      )}
      {include.includes('sign-in') && (
        <Text fontSize="md" fontFamily="Satoshi" pt={5} color="secondary2">
          {t('haveAnAccount')}
          <Link to={routes.auth.signIn.url} style={{ display: 'inline-block' }}>
            <Text color="primary">{t('login')}</Text>
          </Link>
        </Text>
      )}
      <Button
        variant="ghost"
        title={t('downloadApp')}
        mt={4}
        borderWidth="1px"
        borderStyle="dashed"
        borderColor="primary"
        leftIcon={<Icon className="icon" as={DownloadIcon} w={4} h={4} />}
        onClick={() =>
          window.open(process.env.REACT_APP_ANDROID_APP_URL, '_blank')
        }
      />
    </Box>
  );
};

export default AuthSuggestion;
